import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import BreakpointImage from "../../atoms/breakpoint-image"
import Button from "../../atoms/button"
import { Block, Grid, Spacer } from "../../atoms/layout-primitives"
import Text from "../../atoms/text"
import { T } from "../../styles/typography"

import BottomSectionIconGroup from "./bottom-section.icons"

export default function BottomSection(props) {
  const query = useStaticQuery(graphql`
    query {
      securityDesktop: file(
        relativePath: { eq: "4_COMPANY/Security/security control - desk.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      securityImage: file(
        relativePath: { eq: "4_COMPANY/Security/security control.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

    }
  `)

  return (
    <>
      <Grid>
        <Spacer height={{ sm: "48px", md: "64px", lg: "96px" }} />
        {/* Enhanced security and control section */}
        <Block col={{ sm: "1 / -1", md: "3 / -3", lg: "1 / 7" }}>
          <BreakpointImage
            imageVariants={{
              sm: query.securityImage.childImageSharp.fluid,
              md: query.securityImage.childImageSharp.fluid,
              lg: query.securityDesktop.childImageSharp.fluid,
            }}
          />
        </Block>
        <Spacer
          height={{ sm: "32px", md: "48px", lg: "0px" }}
          display={{ lg: "none" }}
        />
        <Block
          col={{ sm: "1 / -1", md: "2 / -2", lg: "8 / -1" }}
          variants={[
            css`
              text-align: center;
            `,
            css``,
            css`
              text-align: left;
              align-self: center;
            `,
          ]}
        >
          <Text
            variants={[
              css`
                ${T.md.h2`500`}
                letter-spacing: 0.05em;
                color: var(--slate);
              `,
              css`
                letter-spacing: 0.08em;
              `,
              css`
                ${T.lg.h2`500`}
              `,
            ]}
          >
            Enhanced Security and Control
          </Text>
          <Text
            variants={[
              css`
                ${T.sm.body`400`}
                margin-top: 24px;
                color: var(--body-text-grey);
              `,
              css`
                ${T.md.body`400`}
              `,
              css`
                ${T.lg.body`400`}
              `,
            ]}
          >
            Mappedin’s infrastructure and products include safeguards to ensure
            secure account access. Keeping your maps and its associated location
            data protected is of the utmost importance to Mappedin.
          </Text>
        </Block>
        

        {/* "---------------" */}

        <BottomSectionIconGroup />


        <Button.ScrollLink
          to="contact-form"
          smooth
          duration={1000}
          variants={{
            sm: {
              gridColumn: "2 / -2",
              justifySelf: "center",
              marginTop: "32px",
            },
            md: {
              marginTop: "48px",
            },
            lg: {
              paddingLeft: 0,
              paddingRight: 0,
              maxWidth: "181px",
              maxHeight: "46px",
            },
          }}
        >
          Book A Demo
        </Button.ScrollLink>
      </Grid>
    </>
  )
}
